import React from 'react';

export default function SpeechBubble(props) {
  const {
    textToDisplay,
    bottom,
    right,
    minHeight,
    height,
    padding,
    width,
    fontSize,
  } = {
    ...props,
  };
  const widthForMobile = width || '';
  const textWidthForMobile = width ? '70px' : '';
  const textSizeForMobile = fontSize || '';

  return (
    <div
      id="speech-bubble"
      style={{
        bottom,
        right,
        minHeight,
        height,
        padding,
        width: widthForMobile,
      }}
      className="bubble sb9"
    >
      <p
        className="speech-bubble-text"
        style={{ width: textWidthForMobile, fontSize: textSizeForMobile }}
      >
        {textToDisplay}
      </p>
    </div>
  );
}
